import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import Link from '../../../Atoms/Link/Link';
import Text from '../../../Atoms/Text/Text';
const BaseBreadCrumbItem = styled.li `
  position: relative;
  list-style-type: none;
  display: flex;
  align-items: center;

  &::after {
    content: ${({ last }) => (last ? 'none' : '""')};
    margin: 4px;
    height: 3px;
    width: 3px;
    background-color: ${({ theme }) => theme.colors.text02};
    border-radius: 50%;
  }
`;
const BaseBreadCrumbItemText = styled.span `
  * {
    font-weight: ${({ last }) => last && 600};
    color: ${({ theme }) => theme.colors.text01};
    text-decoration: none;
    font-size: ${({ small }) => (small ? '12px' : '14px')};

    &:hover {
      text-decoration: underline;
    }
  }
`;
const BreadcrumbItem = ({ itemUrl, itemName, index, last, small, renderItem, }) => (_jsx(_Fragment, { children: _jsxs(BaseBreadCrumbItem, Object.assign({ itemProp: "itemListElement", itemScope: true, itemType: "https://schema.org/ListItem", last: last }, { children: [_jsx(BaseBreadCrumbItemText, Object.assign({ last: last, small: small }, { children: (renderItem === null || renderItem === void 0 ? void 0 : renderItem({ name: itemName, url: itemUrl })) || (_jsx(Link, Object.assign({ dark: true, href: itemUrl, itemProp: "item" }, { children: _jsx(Text, Object.assign({ as: "span", itemProp: "name" }, { children: itemName }), void 0) }), void 0)) }), void 0), _jsx("meta", { content: `${index}`, itemProp: "position" }, void 0)] }), index) }, void 0));
export default BreadcrumbItem;
//# sourceMappingURL=BreadcrumbItem.js.map